export { JiraProductDiscoveryIcon } from './icon';
export { JiraProductDiscoveryLogo } from './logo';